<template>
  <v-app id="inspire" dark>
    <loading/>
    <snackbar/>
    <template v-if="isAuth">
      <v-navigation-drawer v-model="drawerRight" app clipped temporary right>
        <user-menu v-bind:drawerRight="drawerRight" @drawerRight="updateDrawerRight"></user-menu>
      </v-navigation-drawer>

      <v-app-bar
        app
        clipped-right
        color="primary"
        dark
      >
        <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
        <v-toolbar-title>{{ titlePage }}</v-toolbar-title>
        <v-spacer></v-spacer>
        
        <v-btn
          icon
          large
          @click.stop="drawerRight = !drawerRight"
        >
          <v-avatar>
              <v-icon>mdi-account-circle-outline</v-icon>
          </v-avatar>
        </v-btn>
      </v-app-bar>

      <v-navigation-drawer v-model="drawer" app>
          <app-menu></app-menu>
      </v-navigation-drawer>

      <v-navigation-drawer
        v-model="left"
        fixed
        temporary
      ></v-navigation-drawer>
            <v-btn
              absolute
              dark
              fab
              top
              right
              color="pink"
            >
              <v-icon>mdi-plus</v-icon>
            </v-btn>
      <!-- <v-main style="overflow-y: auto; height: 100vh;"> -->
      <v-main>
          <v-container class="fill-height" fluid>
              <!-- {{ route.fullPath }} -->
              <!-- <transition name="view"> -->
                <router-view></router-view>
              <!-- </transition> -->
          </v-container>
      </v-main>

      <v-navigation-drawer
        v-model="right"
        fixed
        right
        temporary
      ></v-navigation-drawer>
    </template>
    <router-view v-else/>
  </v-app>
</template>

<script>
    import router from './router'
    import AppMenu from './components/menus/AppMenu';
    import UserMenu from './components/menus/UserMenu';
    import { mapState } from 'vuex';
    import Loading from './components/utils/Loading';
    import Snackbar from './components/utils/Snackbar';
    export default {
      props: {
          source: String,
      },
      data: () => ({
          titlePage: '',
          drawer: null,
          drawerRight: false,
          right: false,
          left: false,
          // date: new Date(),
          fecha: ''
      }),
      components: {
          'app-menu': AppMenu,
          'user-menu': UserMenu,
          'loading': Loading,
          'snackbar': Snackbar,
      },
      mounted(){
          if(localStorage.getItem("themeDark") != null){
            if(localStorage.getItem("themeDark") === 'true'){
              this.$vuetify.theme.dark = true;
            }else{
              this.$vuetify.theme.dark = false;

            }
          }
          this.titlePage = this.getTitlePage();
          // this.mostrarFecha();
      },
      methods: {
          getTitlePage(){
              this.titlePage = router.history.current.meta.title;
              return this.titlePage;
          },
          updateDrawerRight(valor) {
              this.drawerRight = valor;
          }
          // mostrarFecha(){
          //   this.fecha = 
          //     ((this.date.getDate() < 10) ? '0'+this.date.getDate() : this.date.getDate()) + '/' + 
          //     (((this.date.getMonth()+1) < 10) ? '0'+(this.date.getMonth()+1) : (this.date.getMonth()+1)) + '/' + 
          //     this.date.getFullYear()
          // }
      },
      computed: {
        ...mapState('login', ['authUser', 'isAuth'])
      },
      watch:{
        $route (to, from){
            this.titlePage = this.getTitlePage();
        }
      }
    }
</script>
<style>
  html{
    overflow-y: auto !important;
  }
  .v-footer{
    padding: 2px 16px !important;
    font-size: 12px;
  }
  /* .view-enter-active, .view-leave-active {
    transition: opacity 0.5s ease-in-out, transform 0.5s ease;
  }
  .view-enter-active {
    transition-delay: 0.5s;
  }
  .view-enter {
    opacity: 0;
    transform: translateY(100px);
  }
  .view-enter-to {
    opacity: 1;
    transform: translateY(0px);
  }
  .view-leave {
    opacity: 1;
    transform: translateY(0px);
  }
  .view-leave-to {
    opacity: 0;
    transform: translateY(-100px);
  } */
</style>
